import axios from "axios";

/**
 * 桌布活動「國際 web 版」專用的 axios instance。
 *
 * baseURL 與主 API 相同（REACT_APP_API_URL），但身分是
 * /wallpaper/web-client/login 用 uuid 換來的 access_token
 * （存在 localStorage 的 wallpaper_web_token），
 * 與會員中心的 api_token、log system 的 log_token 各自獨立、不互相覆蓋。
 */
function apiWallpaperWeb() {
	const instance = axios.create({
		baseURL: process.env.REACT_APP_API_URL,
	});

	const setupInterceptors = () => {
		// 請求攔截器：帶上 web-client 的 access_token（型別依後端回傳的 token_type）
		instance.interceptors.request.use(
			(config) => {
				const token = localStorage.getItem("wallpaper_web_token");
				const tokenType =
					localStorage.getItem("wallpaper_web_token_type") || "Bearer";
				if (token) {
					config.headers["Authorization"] = `${tokenType} ${token}`;
				}
				return config;
			},
			(error) => Promise.reject(error),
		);

		// 回應攔截器：直接回傳 res.data
		instance.interceptors.response.use(
			(res) => res.data,
			(error) => Promise.reject(error),
		);
	};

	setupInterceptors();

	return instance;
}

export default apiWallpaperWeb();
